import { Calendar } from "@faire/web/slate/icons/foundation/Calendar";
import { Exclusivity } from "@faire/web/slate/icons/foundation/Exclusivity";
import { Global } from "@faire/web/slate/icons/foundation/Global";
import { Returns } from "@faire/web/slate/icons/foundation/Returns";
import { Shipping } from "@faire/web/slate/icons/foundation/Shipping";
import { IInformationMessage } from "@faire/web-api--source/indigofair/data/IInformationMessage";

export const getShippingDetailsInfoTextIcon = (
  infoText: keyof typeof IInformationMessage.Type | "FULFILLMENT_TIME_CUSTOM"
) => {
  switch (infoText) {
    case "SHIPS_FROM":
      return <Global />;
    case "FIRST_ORDER_PROMO":
    case "FREE_RETURNS_ON_FIRST_ORDER":
      return <Returns />;
    case "EXCLUSIVITY_AVAILABLE":
    case "EXCLUSIVITY_ACTIVE":
      return <Exclusivity />;
    case "FULFILLMENT_TIME_CUSTOM":
    case "GET_IT_BY":
      return <Calendar />;
    case "GUARANTEED_FREE_SHIPPING_THRESHOLD":
      return <Shipping />;
    default:
      return null;
  }
};
